import { Alert, Button, Stack } from '@mui/material';
import type { FC } from 'react';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { shouldShowKycBanner } from '@pflegenavi/shared-frontend/platform';
import { useGetServiceProviderPhoenix } from '@pflegenavi/service-provider-frontend/api';

/**
 * Dashboard banner prompting service providers to complete MangoPay KYC
 * verification while it is still pending (i.e. their documents have not been
 * validated yet).
 */
export const KycVerificationBanner: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: serviceProvider } = useGetServiceProviderPhoenix();

  const handleGoToProfile = useCallback(() => {
    navigate(spAppMainPages.PROFILE);
  }, [navigate]);

  if (!shouldShowKycBanner(serviceProvider?.data)) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{ mb: 3 }}
      action={
        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            onClick={handleGoToProfile}
          >
            {t('service-provider-app.dashboard.complete-kyc-button')}
          </Button>
        </Stack>
      }
    >
      {t('service-provider-app.dashboard.kyc-verification-required')}
    </Alert>
  );
};
